// Mirrors DAT.Platform.Constants.ErrorCodes on the backend. Only the codes callers actually need to
// branch on belong here - add more as they're needed, keeping the numeric value in sync with the
// backend constant of the same name.
export const AgTechApiErrorCodes = {
    ConcurrencyError: 11
} as const;
